import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const CircleIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.6 12.0004C21.6 17.3023 17.3019 21.6004 12 21.6004C6.69807 21.6004 2.4 17.3023 2.4 12.0004C2.4 6.69846 6.69807 2.40039 12 2.40039C17.3019 2.40039 21.6 6.69846 21.6 12.0004Z"
        stroke="currentColor"
        strokeWidth="2"
      />
    </BaseIcon>
  );
};

CircleIcon.displayName = 'CircleIcon';
